import { PageRef } from 'providers/page-ref';

export type SubscribePageParams = {};

export const ISubscribePage: PageRef<SubscribePageParams, void> = {
  pageName: 'SubscribePage',
} as PageRef<SubscribePageParams, void>;
